import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableToolingOld';
import AssignTableTooling from '../../../tooling/assignTableTooling';
import LocaleTooling from '../../../tooling/localeTooling';
import { intl } from '../../../locales/localesConfig';

/* Actions */
import * as assignGroupAdminActions from '../../actions/assignGroupAdmin/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import Select from '../../components/common/inputs/select';
import AssignHeader from '../../components/common/assign/assignHeader';
import AssignMainComponent from '../../components/common/assign/assignMainComponent';
import AssignImportFormPopup from '../../components/common/assign/assignImportFormPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';

const popupIds = {
  importFormPopup: "importFormPopup"
}

const groupByOptions = [
  { value: Constants.assign.groupBy.GROUP, label: intl.formatMessage({id: "common.entities.group"}) },
  { value: Constants.assign.groupBy.CALCULATION_UNIT, label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "common.entities.calculationUnit" })) }
]

class AssignGroupAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormDataGroup: { searchText: '' },
      topControlsFormDataGroupCalculationUnits: { assignSearchText: '' },
      topControlsFormDataCalculationUnit: { searchText: '' },
      topControlsFormDataCalculationUnitGroups: { assignSearchText: '' },
      groupBySelection: Constants.assign.groupBy.GROUP,
      periodIdSelected: '',
      searchTimeoutObject: null
    };
  }
 
  async componentDidMount() {
    await this.props.actions.getPeriodsList();
  }
  
  componentWillUnmount() {
    this.props.actions.resetAssignGroupAdmin();
  }
  
  componentDidUpdate(prevProps) {
    //handle save success feedback
    if ((prevProps.saveGroupCalculationUnit.status == null && this.props.saveGroupCalculationUnit.status != null) ||
       (prevProps.saveCalculationUnitGroup.status == null && this.props.saveCalculationUnitGroup.status != null)) {
      toastr.options = Object.assign(Constants.interface.tostrOptions, { timeOut: Constants.interface.tostrOptionsShortTimeout });
      if(this.props.saveGroupCalculationUnit.status==200 || this.props.saveCalculationUnitGroup.status==200) {
        toastr.success(intl.formatMessage({id: "common.assign.assignSuccess"}),"");
      }
      else if(this.props.saveGroupCalculationUnit.status==423 || this.props.saveCalculationUnitGroup.status==423) {
        toastr.error(intl.formatMessage({id: "common.errors.systemLockedError"}),"");
      }
      else {
        toastr.error(intl.formatMessage({id: "common.assign.assignError"}),""); 
      }        
    }
    
    //handle import download file feedback
    if (prevProps.downloadImport.status == null && this.props.downloadImport.status != null) {
      toastr.options = Constants.interface.tostrOptions;
      if(this.props.downloadImport.status==200) {
        toastr.success(intl.formatMessage({ id: "common.assign.downloadImportFileSuccess" },),"");
      }
      else {
        toastr.error(intl.formatMessage({ id: "common.assign.downloadImportFileFailure" },),"");
      }      
    }
    
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.import.status],
      [this.props.import.status],
      intl.formatMessage({ id: "common.assign.uploadImportSuccess" }),
      null,
      [() => {
        if(InterfaceTooling.popupHasToRender(this.state[popupIds.importFormPopup])) {
          InterfaceTooling.popupHide(popupIds.importFormPopup, this.setState.bind(this));
        }  
      }]  
    );
    
    if (this.props.periodsList.status===200 && prevProps.periodsList.status !==200) {
      if(this.props.periodsList.data.length > 0) {
        let periodIdSelected = this.props.periodsList.data[0].id;
        let selectedPeriod = null;
        if(this.props.fixedPeriodId!="") {
          selectedPeriod = this.props.periodsList.data.find(item => item.id==this.props.fixedPeriodId);
          periodIdSelected = selectedPeriod ? selectedPeriod.id : null;
        }
        this.state.periodIdSelected = periodIdSelected;
        this.props.actions.setPeriodId(periodIdSelected);
        this.fetchGroupList();
        this.fetchCalculationUnitList();
      }
    }
  }

  handleChangeAssignType = (event) => {
    let value = event.target.value;
    
    this.props.actions.softResetAssignGroupAdmin();
    this.setState({
      topControlsFormDataGroup: { searchText: '' },
      topControlsFormDataGroupCalculationUnits: { assignSearchText: '' },
      topControlsFormDataCalculationUnit: { searchText: '' },
      topControlsFormDataCalculationUnitGroups: { assignSearchText: '' },
      groupBySelection: value,
    });
    
    if(value==Constants.assign.groupBy.GROUP) {
      this.fetchGroupList();
    }
    else if(value==Constants.assign.groupBy.CALCULATION_UNIT) {
      this.fetchCalculationUnitList();
    }
  };

  handleChangePeriod = (event) => {
    let value = event.target.value;
    
    this.props.actions.softResetAssignGroupAdmin();
    this.state.periodIdSelected = value;
    this.props.actions.setPeriodId(this.state.periodIdSelected);
    this.setState({
      topControlsFormDataGroup: { searchText: '' },
      topControlsFormDataGroupCalculationUnits: { assignSearchText: '' },
      topControlsFormDataCalculationUnit: { searchText: '' },
      topControlsFormDataCalculationUnitGroups: { assignSearchText: '' }
    });
    
    if(this.state.groupBySelection==Constants.assign.groupBy.GROUP) {
      this.fetchGroupList();
    }
    else if(this.state.groupBySelection==Constants.assign.groupBy.CALCULATION_UNIT) {
      this.fetchCalculationUnitList();
    }
  };
  
  //GROUP FUNCTIONS
  
  getGroupListQueryParams = () => {
    let queryParams = EntityTableTooling.getListQueryParams(this.props.groupList, TableDescriptors.assignGroupGroupList, 
      this.state.topControlsFormDataGroup.searchText, this.state.topControlsFormDataGroup.showDisabledEntities);
    queryParams.period_id = this.state.periodIdSelected;
    queryParams.active = true;
    queryParams.fields_are = [];
    queryParams.searches_are = [];
    return queryParams;
  };  

  fetchGroupList = async() => {
    await this.props.actions.getGroupList(this.getGroupListQueryParams());
  };

  fetchGroupListChangePage = async (event) => {
    EntityTableTooling.fetchListNextPage(event, this.props.groupList, 
      this.getGroupListQueryParams, this.props.actions.getGroupList);
  };

  fetchOrderGroupList = async (event) => {
    EntityTableTooling.fetchListOrder(event, this.props.groupList, 
      this.getGroupListQueryParams, this.props.actions.getGroupList);
  };

  fetchSearchGroupList = async() => {
    EntityTableTooling.fetchListSearch(event, this.getGroupListQueryParams, 
      this.props.actions.getGroupList);
  };

  handleOnChangeGroupTopControls = event => {
    this.setState(EntityTableTooling.handleOnChangeTopControls(event, this.state, "topControlsFormDataGroup", 
      this.fetchSearchGroupList, this.state.searchTimeoutObject));  
  };

  handleOnClickGroup = async event => {
    AssignTableTooling.handleClickOnAssignParent(event, this.getGroupCalculationUnitsListQueryParams, 
      this.props.actions.getGroupCalculationUnitsList, this.state.topControlsFormDataGroupCalculationUnits);
  };

  //GROUP CALCULATION_UNITS FUNCTIONS

  getGroupCalculationUnitsListQueryParams = () => {
    let queryParams = AssignTableTooling.getListQueryParams(this.props.groupCalculationUnitsList, 
      this.state.topControlsFormDataGroupCalculationUnits.assignSearchText);
    queryParams.period_id = this.state.periodIdSelected;
    return queryParams;
  };  

  fetchGroupCalculationUnitsList = async() => {
    await this.props.actions.getGroupCalculationUnitsList(this.getGroupCalculationUnitsListQueryParams());
  };

  fetchGroupCalculationUnitsListChangePage = async (event) => {
    AssignTableTooling.fetchListNextPage(event, this.props.groupCalculationUnitsList, 
      this.getGroupCalculationUnitsListQueryParams, this.props.actions.getGroupCalculationUnitsList);
  };

  fetchSearchGroupCalculationUnitsList = async() => {
    AssignTableTooling.fetchListSearch(event, this.getGroupCalculationUnitsListQueryParams, 
      this.props.actions.getGroupCalculationUnitsList);
  };

  handleOnChangeGroupCalculationUnitsTopControls = event => {
    this.setState(AssignTableTooling.handleOnChangeTopControls(event, this.state, "topControlsFormDataGroupCalculationUnits", 
      this.fetchSearchGroupCalculationUnitsList, this.state.searchTimeoutObject));  
  };

  handleCheckBoxClickGroupCalculationUnits = async event => {
    AssignTableTooling.handleCheckBoxClick(event, this.props.actions.saveGroupCalculationUnit, this.state.periodIdSelected);
  };

  // CALCULATION_UNITS FUNCTIONS

  getCalculationUnitListQueryParams = () => {
    let queryParams = EntityTableTooling.getListQueryParams(this.props.calculationUnitList, TableDescriptors.assignGroupCalculationUnitList, 
      this.state.topControlsFormDataCalculationUnit.searchText, this.state.topControlsFormDataCalculationUnit.showDisabledEntities);
    queryParams.period_id = this.state.periodIdSelected;
    queryParams.active = true;
    queryParams.fields_are = [];
    queryParams.searches_are = [];
    return queryParams;
  };  

  fetchCalculationUnitList = async() => {
    await this.props.actions.getCalculationUnitList(this.getCalculationUnitListQueryParams());
  };

  fetchCalculationUnitListChangePage = async (event) => {
    EntityTableTooling.fetchListNextPage(event, this.props.calculationUnitList, 
      this.getCalculationUnitListQueryParams, this.props.actions.getCalculationUnitList);
  };

  fetchOrderCalculationUnitList = async (event) => {
    EntityTableTooling.fetchListOrder(event, this.props.calculationUnitList, 
      this.getCalculationUnitListQueryParams, this.props.actions.getCalculationUnitList);
  };

  fetchSearchCalculationUnitList = async() => {
    EntityTableTooling.fetchListSearch(event, this.getCalculationUnitListQueryParams, 
      this.props.actions.getCalculationUnitList);
  };

  handleOnChangeCalculationUnitTopControls = event => {
    this.setState(EntityTableTooling.handleOnChangeTopControls(event, this.state, "topControlsFormDataCalculationUnit", 
      this.fetchSearchCalculationUnitList, this.state.searchTimeoutObject));  
  };

  handleOnClickCalculationUnit = async event => {
    AssignTableTooling.handleClickOnAssignParent(event, this.getGroupCalculationUnitsListQueryParams, 
      this.props.actions.getCalculationUnitGroupsList, this.state.topControlsFormDataCalculationUnit);
  };

  //CALCULATION_UNIT GROUPS FUNCTIONS

  getCalculationUnitGroupsListQueryParams = () => {
    let queryParams = AssignTableTooling.getListQueryParams(this.props.calculationUnitGroupsList, 
      this.state.topControlsFormDataCalculationUnitGroups.assignSearchText);
    queryParams.period_id = this.state.periodIdSelected;
    return queryParams;
  };  

  fetchCalculationUnitGroupsList = async() => {
    await this.props.actions.getCalculationUnitGroupsList(this.getCalculationUnitGroupsListQueryParams());
  };

  fetchCalculationUnitGroupsListChangePage = async (event) => {
    AssignTableTooling.fetchListNextPage(event, this.props.calculationUnitGroupsList, 
      this.getCalculationUnitGroupsListQueryParams, this.props.actions.getCalculationUnitGroupsList);
  };

  fetchSearchCalculationUnitGroupsList = async() => {
    AssignTableTooling.fetchListSearch(event, this.getCalculationUnitGroupsListQueryParams, 
      this.props.actions.getCalculationUnitGroupsList);
  };

  handleOnChangeCalculationUnitGroupsTopControls = event => {
    this.setState(AssignTableTooling.handleOnChangeTopControls(event, this.state, "topControlsFormDataCalculationUnitGroups", 
      this.fetchSearchCalculationUnitGroupsList, this.state.searchTimeoutObject));  
  };

  handleCheckBoxClickCalculationUnitGroups = async event => {
    AssignTableTooling.handleCheckBoxClick(event, this.props.actions.saveCalculationUnitGroup, this.state.periodIdSelected);
  };

  //Import functions

  handleDownloadImportSheet = async event => {
    await this.props.actions.downloadImportFile({
      not_assign: document.getElementById('import_show_not_assigned').checked,
      period_id: this.state.periodIdSelected
    });
  };

  handleOnSaveImportForm = async event => {
    let files = [];
    files = document.getElementById('import_file').files;
    files = Object.keys(files).map(key => files[key]);
    document.getElementById('import_file').value = '';
    await this.props.actions.importAssigns(files, {
      period_id: this.state.periodIdSelected    
    });
  };

  handleShowImportFormPopup = event => {
    if(event) {
      event.preventDefault()
    };    
    if(this.props.import.loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(this.state[popupIds.importFormPopup])) {
      InterfaceTooling.popupShow(popupIds.importFormPopup, this.setState.bind(this));
    }
    else {
      InterfaceTooling.popupHide(popupIds.importFormPopup, this.setState.bind(this));
    }
  };

  render() {
    var loadingView = this.props.periodsList.firstLoading || ((this.props.groupList.firstLoading || this.props.calculationUnitList.firstLoading) && this.props.periodsList.status == 200 && this.props.periodsList.data.length>0);
    var errorLoadingView = (this.props.periodsList.status !== null && this.props.periodsList.status !== 200) ||
        (this.props.groupList.status !== null && this.props.groupList.status !== 200) ||
        (this.props.calculationUnitList.status !== null && this.props.calculationUnitList.status !== 200) ||
        (this.props.groupCalculationUnitsList.status !== null && this.props.groupCalculationUnitsList.status !== 200) ||
        (this.props.calculationUnitGroupsList.status !== null && this.props.calculationUnitGroupsList.status !== 200);
    var noPeriodsCreated = this.props.periodsList.status == 200 && this.props.periodsList.data.length==0;
    return (
      <section className="dashboard_content_inner_view assign_admin_container assign_group_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          noPeriodsCreated ? (
            <section>
              <AssignHeader 
                title={intl.formatMessage({id: "assignGroupAdmin.title"})}
              />
              <div className="no_period_selected_wrapper">
                {intl.formatMessage({ id: "common.noPeriodCreated" })}
              </div>
            </section>            
          ) :
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <AssignHeader 
                title={intl.formatMessage({id: "assignGroupAdmin.title"})}
                handleImportFormPopup={this.handleShowImportFormPopup}
              />
              <div className="assign_controls">
                <Select
                  disabled={this.props.fixedPeriodId!=""}
                  value={this.state.periodIdSelected}
                  onChange={this.handleChangePeriod}
                  labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
                  options={InterfaceTooling.getSelectArrayFromArrayOfObjects(this.props.periodsList.data, "id", "name", false)}
                />
                <Select
                  value={this.state.groupBySelection}
                  onChange={this.handleChangeAssignType}
                  labelLocale={<FormattedMessage id="common.controls.groupBy"/>}
                  options={groupByOptions}
                />
              </div>
              {(this.state.groupBySelection==Constants.assign.groupBy.GROUP) && (
                <AssignMainComponent
                  entityTableDescriptor={TableDescriptors.assignGroupGroupList}
                  entityData={this.props.groupList}
                  assignData={this.props.groupCalculationUnitsList}
                  topControlsFormDataEntity={this.state.topControlsFormDataGroup}
                  topControlsFormDataAssign={this.state.topControlsFormDataGroupCalculationUnits}
                  fetchOrderListEntity={this.fetchOrderGroupList}
                  fetchListChangePageEntity={this.fetchGroupListChangePage}
                  handleOnChangeTopControlsEntity={this.handleOnChangeGroupTopControls}
                  handleRowClickEntity={this.handleOnClickGroup}
                  handleOnChangeSearchAssign={this.handleOnChangeGroupCalculationUnitsTopControls}
                  fetchListChangePageAssign={this.fetchGroupCalculationUnitsListChangePage}
                  handleCheckBoxClickAssign={this.handleCheckBoxClickGroupCalculationUnits}
                  saveAssignData={this.props.saveGroupCalculationUnit}
                  parentTitle={<FormattedMessage id="assignGroupAdmin.groupsTitle"/>}
                  assignsTitle={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "assignGroupAdmin.groupCalculationUnitsTitle"}))}
                  noAssignText={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "assignGroupAdmin.groupCalculationUnitsNoSelected"}))}
                  assignTypeLabel={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "calculationUnitAdmin.entityNamePlural"}))}
                />
              )}
              {(this.state.groupBySelection==Constants.assign.groupBy.CALCULATION_UNIT) && (
                <AssignMainComponent
                  entityTableDescriptor={TableDescriptors.assignGroupCalculationUnitList}
                  entityData={this.props.calculationUnitList}
                  assignData={this.props.calculationUnitGroupsList}
                  topControlsFormDataEntity={this.state.topControlsFormDataCalculationUnit}
                  topControlsFormDataAssign={this.state.topControlsFormDataCalculationUnitGroups}
                  fetchOrderListEntity={this.fetchOrderCalculationUnitList}
                  fetchListChangePageEntity={this.fetchCalculationUnitListChangePage}
                  handleOnChangeTopControlsEntity={this.handleOnChangeCalculationUnitTopControls}
                  handleRowClickEntity={this.handleOnClickCalculationUnit}
                  handleOnChangeSearchAssign={this.handleOnChangeCalculationUnitGroupsTopControls}
                  fetchListChangePageAssign={this.fetchCalculationUnitGroupsListChangePage}
                  handleCheckBoxClickAssign={this.handleCheckBoxClickCalculationUnitGroups}
                  saveAssignData={this.props.saveCalculationUnitGroup}
                  parentTitle={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "assignGroupAdmin.calculationUnitsTitle"}))}
                  assignsTitle={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "assignGroupAdmin.calculationUnitGroupsTitle"}))}
                  noAssignText={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "assignGroupAdmin.calculationUnitGroupsNoSelected"}))}
                  assignTypeLabel={intl.formatMessage({id: "groupAdmin.entityNamePlural"})}
                />
              )}
              <AssignImportFormPopup
                handleShowPopup={this.handleShowImportFormPopup}
                handleDownloadImportSheet={this.handleDownloadImportSheet}
                handleButton={this.handleOnSaveImportForm}
                loadingButton={this.props.import.loading}
                fullLoading={this.props.import.loading || this.props.downloadImport.loading}
                statusButton={this.props.import.status}
                errors={this.props.import.errors}
                assignName={<FormattedMessage id="assignGroupAdmin.assignName"/>}
                assigneName={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="assignGroupAdmin.assigneName"/>)}
                popupState={this.state[popupIds.importFormPopup]}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  groupList: state.reducer.assignGroupAdmin.groupList,
  calculationUnitList: state.reducer.assignGroupAdmin.calculationUnitList,
  groupCalculationUnitsList: state.reducer.assignGroupAdmin.groupCalculationUnitsList,
  calculationUnitGroupsList: state.reducer.assignGroupAdmin.calculationUnitGroupsList,
  saveGroupCalculationUnit: state.reducer.assignGroupAdmin.saveGroupCalculationUnit,
  saveCalculationUnitGroup: state.reducer.assignGroupAdmin.saveCalculationUnitGroup,
  import: state.reducer.assignGroupAdmin.import,
  downloadImport: state.reducer.assignGroupAdmin.downloadImport,
  periodsList: state.reducer.assignGroupAdmin.periodsList,
  periodId: state.reducer.assignGroupAdmin.periodId,
  fixedPeriodId: state.reducer.dashboard.fixedPeriodId
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(assignGroupAdminActions, dispatch)
});

AssignGroupAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignGroupAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/assignGroupAdmin/index.jsx